// 32ecc37db61fa70464333dd9db4b756d8a985b28|name=OkResponse|schemaHash=a0820ed99f1f904cbd338b30c6f80ebbd5f0609a|kind=response-wrapper

import { setDefinedValue } from '@myre/common-primitives';

import { parseResponseMetaFromJSON, parseResponseMetaToJSON } from './ResponseMeta';

export function parseOkResponseFromJSON(
  _data,
  options,
) {
  if (!_data) {
    return _data;
  }

  const { contentParser, isContentArray } = options || {};
  const result = {};

  setDefinedValue(result, 'status', _data.status);
  setDefinedValue(result, 'meta', parseResponseMetaFromJSON(_data.meta));
  setDefinedValue(
    result,
    'content',
    isContentArray
      ? Array.isArray(_data.content) && contentParser
        ? _data.content.map(contentParser)
        : _data.content
      : contentParser
        ? contentParser(_data.content)
        : _data.content,
  );

  return result;
}

export function parseOkResponseToJSON(
  _data,
  options,
) {
  if (!_data) {
    return _data;
  }

  const { contentParser, isContentArray } = options || {};
  const result = {};

  setDefinedValue(result, 'status', _data.status);
  setDefinedValue(result, 'meta', parseResponseMetaToJSON(_data.meta));
  setDefinedValue(
    result,
    'content',
    isContentArray
      ? Array.isArray(_data.content) && contentParser
        ? _data.content.map(contentParser)
        : _data.content
      : contentParser
        ? contentParser(_data.content)
        : _data.content,
  );

  return result;
}
